// 작은 chevron-down (12×12) — 상세보기 토글 등에서 사용
interface IconChevronDownTinyProps {
  className?: string
}

export const IconChevronDownTiny = ({ className }: IconChevronDownTinyProps) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className={className}>
    <path d="M3 4L6 7L9 4" stroke="#8F9194" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
)
